import React from 'react';
import './safeDiggingChecklist.scss';
import statesGetChecklistHoc from '../../hoc/statesGetChecklistHoc';
import markdownIt from "markdown-it";
import square from './assets/811_checklist_2x.png';
import {Helmet} from 'react-helmet';


/**
 * The FactsAndStatsPage component.
 *
 * @constructor
 */
export class safeDiggingChecklist extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
    // all the state stuff in this file is here because they wanted
    // to make this page draw from the "all 50 states" checklist api
    // just hardcode a state. it's the same checklist
    this.state = {
      invalidState: false
    };
  }

  componentWillMount() {
    this.props.statesGetChecklistHoc.getChecklist('tx');
  }




  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    const isLoading = this.props.statesGetChecklistHoc.isLoading || false;
    const error = this.props.statesGetChecklistHoc.error || null;
    const checklistData = this.props.statesGetChecklistHoc.checklistInfo || null;
    const hasError = (error || this.state.invalidState) || null;

    let content = null;
    if (checklistData && checklistData[0] && checklistData[0].content) {
      const markdownParser = markdownIt({
        html: false,
        xhtmlOut: true,
        breaks: true,
      });

      content = markdownParser.render(checklistData[0].content);

      // Clean up anchors.
      content = content.replace(/<a[^>]+href="([^"]+)">/ig, (match, p1) => {
        const newUrl = (p1.match(/https?:\/\//)) ? p1 : `http://${p1}`;
        return `<a href="${newUrl}" target="_blank">`;
      });

      // Mutate <li>s to include orange bullets.
      content = content.replace(
        /<li>/ig,
        () => {
          return `<li><img style="position:absolute;top:0;left:0;" src=${square} height="35px" width="35px"  />`
        }
      )
    }

    console.log(content)
    return (
      <div id="safeDiggingChecklist" className="system-page">
         <div className="container">
           <div className="row">
             <div className="col-lg-12">
               <Helmet>
                 <title> Safe Digging Checklist - NEI </title>
                 <meta name = "description" content ="Learn the steps for safe digging using this checklist. Locate underground lines before you dig." />
               </Helmet>
               <div>
                 {(isLoading) && (
                   <div className="loading">
                     Loading...
                   </div>
                 )}
                 {(!isLoading && hasError) && (
                   <div className="alert alert-warning">
                     The checklist information could not be loaded.
                   </div>
                 )}

                 {(!isLoading && !hasError && !checklistData) && (
                   <div className="alert alert-warning">
                     No checklist information was found.
                   </div>
                 )}

                 {(!isLoading && !hasError && checklistData) && (
                   <div className="safe-digging-checklist-data" dangerouslySetInnerHTML={{__html: content}} />
                 )}
               </div>
             </div>
          </div>
        </div>
      </div>
    );
  }
}

safeDiggingChecklist.propTypes = {};

export default statesGetChecklistHoc(
  safeDiggingChecklist
);



// WEBPACK FOOTER //
// ./src/components/pages/safeDiggingChecklist/safeDiggingChecklist.js